// store/pdp/index.js

//#region inicio storage
// No requiere localStorage para este módulo
//#endregion termino storage

//#region inicio state
const state = function() {
  return {
    pdp: [],
  };
};
//#endregion termino state

//inicio mutations
const mutations = {
  setPdp: function(state, pdp) {
    state.pdp = pdp;
  },
};
//#endregion termino mutations

//#region inicio getters
const getters = {};
//#endregion termino getters

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions: {}
};